






































import type { PropType } from "vue"
import type { stadium_reduced_cost } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"

export default Vue.extend({
  name: "StadiumBusinessForm",
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    form    : { type: Object as PropType<stadium_reduced_cost> },
    correct : { type: Object, default() { return {} } },
    show    : { type: Object,
      default() {
        return {
          all             : true,
          save_payment    : true,
          approval_payment: true
        }
      }
    },
  },
  data() {
    return {
      data  : {} as stadium_reduced_cost,
      change: {} as any,
      rules : {
        save_payment    : { required: true, message: "请填写实际节省成本", trigger: "blur" },
        approval_payment: { required: true, message: "请填写节省成本收益核定", trigger: "blur" },
      }
    }
  },
  computed: {
    if_correct() {
      return (key: string): string => {
        let is_correct = ""
        if (Object.prototype.hasOwnProperty.call(this.form, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
          if (this.change.id && this.change.id > 0) is_correct = ""
          else is_correct = "is_correct"
        }
        return is_correct
      }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        const data = this.$deep_copy(this.form)
        this.data = data
      })
    },
    show_correct(key: string): boolean {
      let correct = false
      if (Object.prototype.hasOwnProperty.call(this.form, key) && Object.prototype.hasOwnProperty.call(this.change, key)) {
        if (this.change.id && this.change.id > 0) correct = true
        else correct = false
      }
      return correct
    },
    submit() {
      const params = this.$deep_copy(this.data)
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        if (valid) {
          params.estimate_id = this.id
          this.$emit("modify", params)
        }
      })
    },
    check(): boolean {
      let checked = false
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        checked = valid
      })
      return checked
    },
  },
  watch: {
    data: {
      handler() {
        this.$nextTick(() => {
          if (this.correct.id == undefined) this.submit()
          this.change = this.$deep_copy(this.correct)
        })
      },
      deep   : true
    }
  }
})

